/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Image_Prefix_LabelInputs */



/**
* | output |
* | --- |
* | "Image Prefix" |
*
* @param {Image_Export_Image_Prefix_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_image_prefix_label = /** @type {((inputs?: Image_Export_Image_Prefix_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Image_Prefix_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prefixe d'image")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildpräfix")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prefisso immagine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Префикс изображения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Prefijo de imagen")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("图像前缀")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画像プレフィックス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छवि उपसर्ग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prefixo da imagem")
	return /** @type {LocalizedString} */ ("Image Prefix")
});